module.exports = __webpack_public_path__ + "img/MT.5cae1bb2.svg";